import { Entity } from "../../types/entity.type";
import { UserInfo, UserTypes } from "../../types/user-info";

export function allowDeleteEntity(entity: Entity, user: UserInfo): boolean {
  if (
    user.isGlobalAdmin() ||
    (user.isPartnerAdmin() &&
      (entity?.extraInfo.createdByType === UserTypes.Partner ||
        entity?.extraInfo.createdByType === UserTypes.Company)) ||
    (user.isCompanyAdmin() && entity?.extraInfo.createdByType === UserTypes.Company)
  ) {
    return true;
  }
  return false;
}

export function allowUpdateEntity(entity: Entity, user: UserInfo): boolean {
  if (user.hasRight(["admin", "manager"])) {
    if (
      user.isGlobal() ||
      (user.isPartner() &&
        (entity?.extraInfo.createdByType === UserTypes.Partner ||
          entity?.extraInfo.createdByType === UserTypes.Company)) ||
      (user.isCompany() && entity?.extraInfo.createdByType === UserTypes.Company)
    )
      return true;
  }
  return false;
}
